import { useEffect, useMemo, useState } from 'react';
import { categories, sports } from '../data/sports';
import { Icon } from './Icon';

type Props = {
  open: boolean;
  selected: string[];
  anySport: boolean;
  onClose: () => void;
  onApply: (selected: string[], anySport: boolean) => void;
};

export function SportPicker({ open, selected, anySport, onClose, onApply }: Props) {
  const [draft, setDraft] = useState(selected);
  const [draftAny, setDraftAny] = useState(anySport);
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (open) {
      setDraft(selected);
      setDraftAny(anySport);
      setQuery('');
    }
  }, [open, selected, anySport]);

  const visible = useMemo(() => sports.filter((sport) => sport.name.includes(query.trim())), [query]);
  if (!open) return null;

  const toggle = (id: string) => {
    setDraftAny(false);
    setDraft((value) => value.includes(id) ? value.filter((item) => item !== id) : [...value, id]);
  };

  return <div className="sheet-backdrop" role="presentation" onMouseDown={onClose}>
    <section className="sheet" role="dialog" aria-modal="true" aria-label="운동 선택" onMouseDown={(event) => event.stopPropagation()}>
      <div className="sheet-handle" />
      <div className="sheet-header">
        <div><p className="eyebrow">운동 선택</p><h2>어떤 운동을 할까요?</h2></div>
        <button className="icon-button" onClick={onClose} aria-label="닫기"><Icon name="close" /></button>
      </div>
      <label className="sport-search"><Icon name="search" size={19}/><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="운동 이름 검색" /></label>
      <button className={`any-sport-card ${draftAny ? 'selected' : ''}`} onClick={() => { setDraftAny(true); setDraft([]); }}>
        <span className="any-icon">✨</span><span><strong>아무 운동이나 좋아요</strong><small>종목보다 함께하는 사람이 중요해요</small></span>
        <span className="select-dot">{draftAny && <Icon name="check" size={15} strokeWidth={2.5}/>}</span>
      </button>
      <div className="sport-list">
        {categories.map((category) => {
          const items = visible.filter((sport) => sport.category === category);
          if (!items.length) return null;
          return <div className="sport-section" key={category}>
            <h3>{category}</h3>
            <div className="sport-grid">
              {items.map((sport) => <button key={sport.id} className={`sport-choice ${draft.includes(sport.id) ? 'selected' : ''}`} onClick={() => toggle(sport.id)}>
                <span className="sport-emoji">{sport.emoji}</span><span>{sport.name}</span>
                {draft.includes(sport.id) && <span className="mini-check"><Icon name="check" size={12} strokeWidth={3}/></span>}
              </button>)}
            </div>
          </div>;
        })}
      </div>
      <div className="sheet-footer"><button className="primary-button" disabled={!draftAny && draft.length === 0} onClick={() => onApply(draft, draftAny)}>{draftAny ? '아무 운동이나 찾기' : `${draft.length}개 운동 선택 완료`}</button></div>
    </section>
  </div>;
}
